import React, { Component } from 'react';
import PropTypes from 'prop-types';
import AccordionItem from './AccordionItem';

class AccordionGroup extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { s3BasePath, children, dividerComp, handleTriggerClick, iconPosition, isDesktop, openPosition } = this.props;

    const nodes = this.props.children.map((node, index) => {
      if (!node) {
        return null;
      }
      const { title } = node.props;
      const { margin } = node.props;
      const { isFirst } = node.props;

      return (
        <AccordionItem
          key={`accordion-${title}`}
          itemPosition={index}
          margin={margin}
          isFirst={isFirst}
          s3BasePath={s3BasePath}
          handleTriggerClick={handleTriggerClick}
          open={openPosition === index}
          title={title}
          dividerComp={dividerComp}
          iconPosition={iconPosition}
          isDesktop={isDesktop}
        >
          {node}
        </AccordionItem>
      );
    });

    return children ? <div>{nodes}</div> : null;
  }
}

AccordionGroup.propTypes = {
  openPosition: PropTypes.number,
  handleTriggerClick: PropTypes.func,
  children: PropTypes.array,
  dividerComp: PropTypes.element,
  iconPosition: PropTypes.string,
  isDesktop: PropTypes.bool,
  margin: PropTypes.string,
  s3BasePath: PropTypes.string.isRequired,
};

export default AccordionGroup;
